export default class ModalLoginConfirmResetPasswordController {
	/* @ngInject */
	constructor($uibModalInstance, username) {
		this.$uibModalInstance = $uibModalInstance;
		this.username = username;
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}

	ok() {
		this.$uibModalInstance.close();
	}
}
